<template>

    <div v-if="results.length >0" class="result-group search-result-group">

        <loader :loading="resultState === 'updating'" class="loading-container-overlay"></loader>
        <div v-if="headline" class="row">
            <div class="col-sm-12">
                <div class="headline">
                    {{ headline }}
                </div>
            </div>
        </div>
        <div class="row flex-row">

            <slot v-for="result in results" name="result" v-bind:currentResultLanguage="currentResultLanguage"
                  v-bind:result="result">

                <component v-bind:is="getDownloadType(result)" v-bind:result="result"></component>

            </slot>
        </div>
    </div>
</template>

<script>
    import DownloadResultVideo from "./DownloadResultVideo";
    import DownloadResultFile from "./DownloadResultFile";
    import DocumentResult from "./DocumentResult";
    import FaqResultEntry from "./FaqResultEntry";
    import Loader from "./Loader";

    const resultTemplates = {
        'default': DownloadResultFile,
        'video': DownloadResultVideo,
        'videos': DownloadResultVideo,
        'page': DocumentResult,
        'faqdev': FaqResultEntry,
    };

    export default {
        name: "SearchResultGroup",
        props: {
            rawResults: {type: Object},
            sorting: {type: String, default: 'asc'},
            headline: {type: String},
            currentResultLanguage: {type: String}
        },
        data: function () {
            return {
                results: [],
                sortedResults: null
            }
        },
        components: {
            DownloadResultVideo,
            Loader
        },
        computed: {
            resultState() {
                return this.$store.state.status.results;
            },
            resultLanguage() {
                return this.$store.state.selections.resultLanguage;
            },

        },
        watch: {
            rawResults() {
                this.updateResults();
            },
            sorting() {
                this.sortResults();
            },
            resultLanguage(newVal, oldVal) {
                this.updateResults();
                return;
                if (!this.result)
                    return;
                if (this.result.languages[newVal]) {
                    this.fields = this.result.languages[newVal].fields;
                    return;
                }

                if (this.result.language[FALLBACK_LANGUAGE]) {
                    this.fields = this.result.languages[FALLBACK_LANGUAGE].fields;

                }
            }

        },
        methods: {
            sortResults() {
                if (this.sorting === 'asc') {
                    return this.sortAsc();
                }

                if (this.sorting === 'desc') {
                    return this.sortDesc();
                }

                if (this.sorting === 'date_asc') {
                    return this.sortDate();
                }

                if (this.sorting === 'date_desc') {
                    return this.sortDate('desc');
                }

                if (this.sorting === 'relevance') {
                    return this.sortRelevance();
                }

                return this.sortRelevance();

            },
            updateResults() {
                this.results = [];
                for (var k in this.rawResults) {
                    if (this.rawResults.hasOwnProperty(k)) {
                        var result = this.rawResults[k];
                        result = this.mapResultFields(result);
                        this.results.push(result);
                    }
                }
                this.sortResults();
            },
            mapResultFields(results) {
                let result = {fields: {}, id: null, type: results.type, indexname: results.indexname};
                let languageResult = null;

                const language = this.resultLanguage ? this.resultLanguage : this.$store.state.language;
                const fallbackLanguage = this.$store.state.fallbackLanguage;
                const skip = ['existing_languages', 'level_0', 'level_1', 'level_2', 'level_3'];
                if (results.type !== 'page') {
                    if (results[language]) {
                        languageResult = results[language];
                    }
                    if (!languageResult) {
                        languageResult = results[fallbackLanguage];

                        if (!languageResult) {
                            languageResult = results['de'] ? results.de : results[Object.keys(results).shift()];

                        }
                    }
                    if (languageResult == null) {
                    }
                } else {
                    languageResult = results;
                }


                for (var key in languageResult.fields) {

                    if (languageResult.fields.hasOwnProperty(key)) {
                        let item = languageResult.fields[key];
                        if (item.length > 1 || skip.indexOf(key) !== -1) {
                            result.fields[key] = item;
                        } else {

                            if (isNaN(item[0])) {
                                result.fields[key] = item[0];
                            } else {
                                if (key === '_date_') {
                                    result.fields[key] = new Date(item[0] * 1000)
                                } else {
                                    result.fields[key] = parseInt(item[0]);
                                }

                            }
                        }
                    }
                }
                result.languages = results;
                result.score = results.score;
                result.id = languageResult.id;
                return result;
            },
            sortAsc() {

                this.results.sort(function (a, b) {
                    //var a = $this.results[keyA];
                    //var b = $this.results[keyB];

                    if (a.fields.title < b.fields.title) {
                        return -1;
                    }
                    if (a.fields.title > b.fields.title) {
                        return 1;
                    }
                    return 0;
                });
            },
            sortDesc() {

                this.results.sort(function (a, b) {
                    //var a = $this.results[keyA];
                    //var b = $this.results[keyB];

                    if (a.fields.title < b.fields.title) {
                        return 1;
                    }
                    if (a.fields.title > b.fields.title) {
                        return -1;
                    }
                    return 0;
                });
            },
            sortDate(order) {
                if (!order) order = 'asc';

                this.results.sort(function (a, b) {
                    if (order === 'asc')
                        return a.fields._date_ - b.fields._date_;
                    return b.fields._date_ - a.fields._date_;
                });
            },
            sortRelevance() {

                this.results.sort(function (a, b) {
                    //var a = $this.results[keyA];
                    //var b = $this.results[keyB];

                    return a.score > b.score ? -1 : 1;

                });
            },
            getDownloadType(result) {
                if (resultTemplates[result.indexname]) {
                    return resultTemplates[result.indexname];
                }

                return resultTemplates['default'];
            }
        },
        created: function () {
            this.updateResults();
        }
    }
</script>

<style scoped>

</style>
